// extracted by mini-css-extract-plugin
export var csatScore = "_j5-5";
export var header = "_j5-1";
export var panelWrapper = "_j5-2";
export var postPreview = "_j5-3";
export var rightContent = "_j5-0";
export var wrappingText = "_j5-4";